(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
function redFooterLayout() {
  const desktop = window.matchMedia('(min-width: 750px)').matches;
  document.querySelectorAll('[data-red-footer-menu]').forEach(menu => { menu.open = desktop; });
}
redFooterLayout();
window.matchMedia('(min-width: 750px)').addEventListener('change', redFooterLayout);
document.addEventListener('shopify:section:load', redFooterLayout);
document.addEventListener('click', event => {
  const summary = event.target.closest('.red-footer__menu summary');
  if (summary && window.matchMedia('(min-width: 750px)').matches) event.preventDefault();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-red-brand-sort]')) return;
    const destination = new URL(window.location.href);
    destination.searchParams.set('sort_by', select.value);
    destination.searchParams.delete('page');
    destination.hash = '';
    window.location.assign(destination.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
